import { useEffect, useState } from "react";
import style from "./EstimationNav.module.css";
import { useSelector } from "react-redux";
import { selectors as EstimationSelectors } from "redux/slices/v2/EstimationReducer";

function EstimationNav({ t, activeStep }: { t: any; activeStep: number }) {
  const [activeStepNum, setActiveStepNum] = useState(activeStep);
  const getWidthIncrease = (version = "light") => {
    if (activeStepNum == 0) return 10;
    if (activeStepNum == 1) return 10;
    if (activeStepNum == 2) return 22;
    if (activeStepNum == 3) return 34;
    if (activeStepNum == 4) return 46;
    if (activeStepNum == 5) return 58;
    if (activeStepNum == 6) return 70;
    if (activeStepNum == 7) return 82;
    if (activeStepNum == 8 && version == "light") return 20;
    if (activeStepNum == 8 && version !== "light") return 90;
    return 100;
  };

  const version: any = useSelector<
    "vente" | "light" | "complete" | "estimation"
  >(EstimationSelectors.versionSelector);

  useEffect(() => {
    setActiveStepNum(activeStep);
  }, [activeStep]);
  return (
    <div className={style.navContainer}>
      <div className={style.title}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: "32px",
          }}
        >
          <a className={style.logoDesk} href="https://agenz.ma">
            <img
              src={"https://images.agenz.ma/uploads/agenz-logo_250x250.webp"}
              alt="logo-agenz"
              width={140}
              height={60}
            />
          </a>
          <a className={style.logoMob} href="https://agenz.ma">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 0C5.37231 0 0 5.37231 0 12C0 18.6277 5.37231 24 12 24C18.6277 24 24 18.6277 24 12C24 5.37231 18.6277 0 12 0ZM4.18985 16.2702L2.43138 14.5117C2.38892 14.4692 2.38892 14.4009 2.43138 14.3585L6.15508 10.6348C6.18554 10.6043 6.20215 10.5628 6.20215 10.5203V7.00339C6.20215 6.94339 6.25015 6.89538 6.31015 6.89538H8.796C8.856 6.89538 8.904 6.94339 8.904 7.00339V7.68923C8.904 7.76123 8.99169 7.79723 9.04246 7.74646L11.9252 4.86369C11.9677 4.82123 12.036 4.82123 12.0785 4.86369L15.804 8.58923C15.8465 8.63169 15.8465 8.7 15.804 8.74246L14.0455 10.5009C14.0031 10.5434 13.9348 10.5434 13.8923 10.5009L12.0785 8.68615C12.036 8.64369 11.9677 8.64369 11.9252 8.68615L4.34308 16.2702C4.30062 16.3126 4.23231 16.3126 4.18985 16.2702ZM20.6769 11.6649L20.2043 11.1923C20.1618 11.1498 20.0935 11.1498 20.0511 11.1923L12.0785 19.1649C12.036 19.2074 11.9677 19.2074 11.9252 19.1649L8.19969 15.4394C8.15723 15.3969 8.15723 15.3286 8.19969 15.2862L9.95815 13.5277C10.0006 13.4852 10.0689 13.4852 10.1114 13.5277L11.9252 15.3415C11.9677 15.384 12.036 15.384 12.0785 15.3415L18.1403 9.27969C18.1828 9.23723 18.1828 9.16892 18.1403 9.12646L17.6677 8.65385C17.6215 8.60769 17.6465 8.52831 17.7102 8.51631L21.384 7.85169C21.4394 7.84154 21.4883 7.89046 21.4782 7.94585L20.8135 11.6197C20.8015 11.6843 20.7231 11.7092 20.676 11.6622L20.6769 11.6649Z"
                fill="#00B4FF"
              />
            </svg>
          </a>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>
            {activeStepNum === 0
              ? `${t("Étape")} ${1} : ${t("Adresse du bien")}`
              : activeStepNum === 1
              ? `${t("Étape")} ${activeStepNum} : ${t("Adresse du bien")}`
              : [2, 3, 4, 5].includes(activeStepNum)
              ? `${t("Étape")} 2 : ${t("À propos de ce bien")}`
              : activeStepNum === 6
              ? `${t("Étape")} 3 : ${t("Le bien et vous")}`
              : activeStepNum === 7
              ? `${t("Étape")} 4 : ${t("Nous calculons votre estimation")}`
              : activeStepNum === 8
              ? `${t("Étape")} 2 : ${t("Le bien et vous")}`
              : activeStepNum === 9
              ? `${t("Étape")} ${version == "light" ? "3" : "4"} : ${
                  version == "light"
                    ? t("Demandez à être rappeler")
                    : t("Découvrez votre estimation")
                }`
              : ""}
          </h3>
        </div>
      </div>
      <div className={style.progessBar}>
        {
          <div
            className={style.initialPercent}
            style={{ width: `${getWidthIncrease(version)}%` }}
          ></div>
        }
      </div>
    </div>
  );
}

export default EstimationNav;
